import React from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import './Choose.css'
import quality from '../../../../assets/img/quality.webp'
import reliability from '../../../../assets/img/reliability.webp'
import competence from '../../../../assets/img/competence.webp'
import flexibility from '../../../../assets/img/flexibility.webp'

function Choose() {

    const chooseTab = [
        {
            tabs: "Quality"
        },
        {
            tabs: "Reliability"
        },
        {
            tabs: "Competence"
        },
        {
            tabs: "Flexibility"
        },
    ]
    const chooseTabpanel = [
        {   
            title: "Quality",
            Desc: "At 360 Bytes, quality comes first. We make sure every solution is designed with care and delivered with precision. Our focus on detail and dedication to creating meaningful results help us bring real value to every project.",
            img: quality 
        },
        {
            title: "Reliability",
            Desc: "You can always count on us to deliver. We believe in keeping our promises and supporting our clients at every stage of the journey. With a strong track record of successful projects, we provide consistency and peace of mind.",
            img: reliability 
        },
        {
            title: "Competence",
            Desc: "Our team brings together knowledge, creativity, and experience across multiple industries and technologies. By combining technical expertise with practical insight, we build solutions that fit your business needs and help you stay ahead.",
            img: competence 
        },
        {
            title: "Flexibility",
            Desc: "We understand that every business has its own goals and challenges. That is why we adjust our approach to fit your needs, whether it is a large-scale project or a quick assignment. Our ability to adapt makes us a partner who grows with you.",
            img: flexibility 
        },
    ]

  return (
    <section className='hmchoose-sec'>
       <div className='container'>
            
            <Tabs>
                <TabList>
                    {
                       chooseTab.map((Choose, index)=>(
                        <Tab key={index}><span></span> {Choose.tabs}</Tab>
                       )) 
                    }
                    
                </TabList>

                {
                    chooseTabpanel.map((Choose, index)=>(
                        <TabPanel key={index}>
                        <div className='hmchoose-mn'>
                            <div className='hmchoose-txt'>
                                <div className='mn-head'> 
                                <h5>Why Choose 360 Bytes</h5>
                                <h3>{Choose.title}</h3> 
                                </div>
                                <p>{Choose.Desc}</p>
                            </div>
                            <div className='hmchoose-img'><img src={Choose.img} alt={Choose.title} width={600} height={400} loading="lazy" /></div>
                        </div>
                        </TabPanel>
                    )) 
                }
                
            </Tabs>
       </div>
    </section>
  )
}

export default Choose
